import { isHttpMethod } from "@scalar/helpers/http/is-http-method";
import { objectKeys } from "@scalar/helpers/object/object-keys";
import { getResolvedRef } from "../../helpers/get-resolved-ref.js";
import { getTag } from "./get-tag.js";
const createWebhookEntry = (ref, method, name = "Unknown", title = "Unknown", titlesMap, getWebhookId, tag) => {
  const id = getWebhookId({ name, method }, tag);
  titlesMap.set(id, title);
  return {
    id,
    title,
    name,
    ref,
    method,
    type: "webhook"
  };
};
const traverseWebhooks = (content, tagsMap, titlesMap, getWebhookId) => {
  const untagged = [];
  Object.entries(content.webhooks ?? {}).forEach(([name, pathItemObject]) => {
    const pathKeys = objectKeys(pathItemObject ?? {}).filter((key) => isHttpMethod(key));
    pathKeys.forEach((method) => {
      const _operation = pathItemObject?.[method];
      const operation = getResolvedRef(_operation);
      if (!operation) {
        return;
      }
      if (operation["x-internal"] || operation["x-scalar-ignore"]) {
        return;
      }
      const ref = `#/webhooks/${name}/${method}`;
      if (operation.tags?.length) {
        operation.tags.forEach((tagName) => {
          const { tag } = getTag(tagsMap, tagName);
          tagsMap.get(tagName)?.entries.push(
            createWebhookEntry(ref, method, name, operation.summary ?? name, titlesMap, getWebhookId, tag)
          );
        });
      } else {
        untagged.push(createWebhookEntry(ref, method, name, operation.summary ?? name, titlesMap, getWebhookId));
      }
    });
  });
  return untagged;
};
export {
  traverseWebhooks
};
//# sourceMappingURL=traverse-webhooks.js.map
